import {
  IS_FETCHING_LOGIN,
  IS_SUBSCRIPTION_INACTIVE,
  LOG_OUT,
  SET_AUTH_ID,
  SET_IS_LOGIN_ERROR,
  SET_LOGIN_ERROR_MESSAGE,
  SET_ORGANIZATION_ACCOUNT,
  SET_PARTICIPANT,
  SET_PARTICIPANT_TYPE,
} from "../actions/actions-types";

const initialState = {
  participantType: undefined,
  isSubscriptionInactive: false,
  isFetchingLogin: false,
  isLoginError: false,
  loginErrorMessage: "",
  authId: "",
  stripeParticipant: {
    profileId: "",
    name: "",
    lastName: "",
    subscriptionStatus: "",
    email: "",
  },
  organization: {
    id: undefined,
    name: undefined,
    promotionCode: "",
    settings: {
      isContentFunctionalityEnabled: false,
      isFinancesVisibilityEnabled: false,
      suscriptionEndDate: null,
      isLegacy: false,
      organizationId: undefined,
      trialPeriodDays: undefined,
      sessionTimeoutSeconds: null,
    },
  },
};

export const loginReducer = (state = initialState, action) => {
  if (action.type === SET_AUTH_ID) {
    return {
      ...state,
      authId: action.payload.authId,
    };
  }

  if (action.type === SET_ORGANIZATION_ACCOUNT) {
    return {
      ...state,
      organization: action.payload.organization,
    };
  }

  if (action.type === IS_FETCHING_LOGIN) {
    return {
      ...state,
      isFetchingLogin: action.payload.isFetching,
    };
  }

  if (action.type === SET_IS_LOGIN_ERROR) {
    return {
      ...state,
      isLoginError: action.payload.isError,
    };
  }

  if (action.type === SET_LOGIN_ERROR_MESSAGE) {
    return {
      ...state,
      loginErrorMessage: action.payload.errorMessage,
    };
  }

  if (action.type === LOG_OUT) {
    return {
      ...initialState,
    };
  }

  if (action.type === IS_SUBSCRIPTION_INACTIVE) {
    return {
      ...state,
      isSubscriptionInactive: action.payload,
    };
  }

  if (action.type === SET_PARTICIPANT) {
    return {
      ...state,
      stripeParticipant: action.payload,
    };
  }

  if (action.type === SET_PARTICIPANT_TYPE) {
    return {
      ...state,
      participantType: action.payload,
    };
  }

  return state;
};
